import gaDimensionsBuilder from 'helpers/gaDimensionsBuilder';
import { getAppData, setCacheTags, setCanonical } from 'helpers/initializePage';
import { getValidatedRequest } from 'helpers/resources';
import { ROUTE_NAMES } from 'routes';
import Post from 'screens/resources/post';
import { contentfulResourcesService } from 'services/contentful';
import getApp from 'services/getapp';
import initializeExperiments from 'services/launchDarkly';

const ROUTE_NAME = 'resources_post';

export const getServerSideProps = async (ctx) => {
  const { query, req, res } = ctx;
  const getAppService = getApp(req);
  const contentfulService = contentfulResourcesService({
    preview: ctx.query.preview,
    environment: ctx.req?.headers['fe-contentful-env'],
  });

  const [experiments, post, topics, user] = await Promise.all([
    initializeExperiments({
      ctx,
      pageType: ROUTE_NAMES.RESOURCES,
    }),
    getValidatedRequest(
      !!query.slug,
      contentfulService.getPostBySlug,
      query.slug
    ),
    contentfulService.fetchTopics(),
    getAppService.getUser().catch(() => null),
  ]);

  const appData = { ...getAppData(ctx), experiments };

  if (post?.hasRedirect)
    return {
      redirect: {
        destination: post.redirectUrl,
        statusCode: 301,
      },
    };
  const relatedPosts = await contentfulService.getRelatedPosts(post);
  if (ctx.query.page < 1 || !post) {
    res.statusCode = 404;

    // server errors
    return {
      props: {
        error: {
          statusCode: 404,
        },
        appData: {
          ...appData,
          header: {
            ...appData.header,
            user,
          },
        },
      },
    };
  }

  ctx.req.APP_DATA = appData; // We pass in current Request this info to Document in order to avoid double calculation.
  const productSlugs = Object.values(post.content.links)
    .filter((link) => link !== null && link['__typename'] === 'ContentProduct')
    .map((link) => link.slug);

  setCanonical(ctx);
  setCacheTags(ctx, ROUTE_NAMES.RESOURCES);
  if (process.env.TARGET_ENV === 'production' && !req.url?.includes('?')) {
    res.setHeader('X-Robots-Tag', 'index, follow');
  }

  if (process.env.NODE_ENV === 'production' && post?.titleImage?.url) {
    const imagePost = `<${post.titleImage.url}?fm=jpg&fl=progressive&w=640>; rel=preload; as=image`;

    res.setHeader('link', [res.getHeader('link'), imagePost]);
  }

  return {
    props: {
      post,
      topics,
      relatedPosts,
      productSlugs,
      appData: {
        ...appData,
        header: {
          ...appData.header,
          user,
        },
        head: {
          google_analytics: {
            dimensions: gaDimensionsBuilder({ route_name: ROUTE_NAME }),
            content_group: ROUTE_NAME,
          },
        },
        route: ROUTE_NAME,
      },
    },
  };
};

export default Post;
